import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../shared/services/user.service';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UserAuthService } from '../shared/services/auth/user-auth.service';
import { CommonHttpClient } from '../shared/services/common/common-http.service';

interface VersionInfo {
  latestVersion: string;
  fileName: string;
  downloadUrl: string;
}


@Component({
  selector: 'app-check-version',
  templateUrl: './check-version.component.html',
  styleUrls: ['./check-version.component.css']
})
export class CheckVersionComponent implements OnInit {

  latestAppVersion: string;
  clientAppVersion: string;
  updateAvailable = false;
  loading = true;
  error: string = null;
  downloadUrl: string;
  latestFileName: string;
  private apiUrl = 'https://www.titaniumsecure.io:3000';
  param: any;

  constructor(private _location: Location, private router: Router, private route: ActivatedRoute,
    private http: HttpClient, private userService: UserService, private ngxloader: NgxUiLoaderService,
    private modalService: NgbModal, private userAuth: UserAuthService, private commonHttpInit: CommonHttpClient) {
    this.param = route.snapshot.params.param;
  }

  ngOnInit(): void {
    //this.ccService.destroy();
    
    this.route.params.subscribe(params => {
      console.log("in");
      console.log(this.param);
      if (this.param != null) {
        this.clientAppVersion = this.param
        console.log(this.clientAppVersion)
        this.fetchLatestVersion();
      } else {
        this.error = 'No version parameter provided in URL';
        this.loading = false;
      }
    });
  }

  fetchLatestVersion(): void {
    this.http.get<VersionInfo>(`${this.apiUrl}/api/latest-version`).subscribe(
      (data) => {
        this.latestAppVersion = data.latestVersion;
        this.downloadUrl = data.downloadUrl;
        this.latestFileName = data.fileName;
        this.checkVersion();
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching latest version', error);
        this.error = 'Unable to check for updates. Please try again later.';
        this.loading = false;
      }
    );
  }

  private checkVersion(): void {

    const clientParts = this.clientAppVersion.split('.');
    const latestParts = this.latestAppVersion.split('.');

    // Compare version
    for (let i = 0; i < Math.max(clientParts.length, latestParts.length); i++) {
      const clientPart = parseInt(clientParts[i] || '0');
      const latestPart = parseInt(latestParts[i] || '0');

      if (clientPart < latestPart) {
        this.updateAvailable = true;
        return;
      } else if (clientPart > latestPart) {
        this.updateAvailable = false;
        return;
      }
    }

    // versions are identical
    this.updateAvailable = false;
  }
}
